import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import FavoriteStarButton from '../../../components/favorites/FavoriteStarButton';
import { getCategoryLabel } from '../../../data/systemModels';
import { FAVORITE_TYPE_SYSTEM } from '../../../services/favoriteModelsService';

const SystemModelCard = ({ model }) => {
  const navigate = useNavigate();
  const categoryLabel = getCategoryLabel(model.category);

  const handleOpen = () => {
    navigate(
      `/contract-generator?document_id=${encodeURIComponent(String(model.id))}`
    );
  };

  return (
    <div className="relative flex flex-col bg-card border border-border rounded-xl p-6 shadow-elevation-sm transition-all duration-300 hover:shadow-elevation-md hover:border-primary/20">
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-primary/10 shrink-0">
          <Icon name="FileText" size={22} className="text-primary" />
        </div>
        <div className="flex items-center gap-1">
          <FavoriteStarButton type={FAVORITE_TYPE_SYSTEM} id={model.id} size={18} />
          <Button
            type="button"
            variant="outline"
            size="icon"
            iconName="Plus"
            aria-label={`Abrir ${model.name}`}
            onClick={handleOpen}
          />
        </div>
      </div>

      <div className="space-y-2 flex-1">
        <div>
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            Nome do modelo
          </p>
          <p className="text-base font-semibold text-foreground mt-0.5">
            {model.name}
          </p>
        </div>
        <div>
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            Categoria
          </p>
          <p className="text-sm text-foreground mt-0.5">{categoryLabel}</p>
        </div>
      </div>
    </div>
  );
};

export default SystemModelCard;
